import { render } from "./views/CertificateGenerate.html?vue&type=template&id=1b8af2bf&external"
import script from "./CertificateGenerate.vue?vue&type=script&lang=js"
export * from "./CertificateGenerate.vue?vue&type=script&lang=js"

import "./CertificateGenerate.vue?vue&type=style&index=0&id=1b8af2bf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__